import { Stack, Typography } from "@mui/material";
import Iconify from "../iconify";

export function EmptyState() {
    return (
        <Stack
            height="100%"
            alignItems="center"
            justifyContent="center"
            spacing={1.5}
        >
            <Iconify
                icon="line-md:close-circle"
                width={80}
                height={80}
                color="text.secondary"
            />
            <Typography color="text.secondary">Nenhum dado encontrado</Typography>
        </Stack>
    );
}
